import React from 'react';
import {Box} from '@mui/material';
import {BaseDialog} from '@resurs-internal/mui';
import {useVerifyContactFlow} from './useVerifyContactFlow';
import {VerifyContactStepViewSuccess} from './VerifyContactStepView/VerifyContactStepViewSuccess';
import {VerifyContactStepViewCode} from './VerifyContactStepView/VerifyContactStepViewCode';
import {VerifyContactStepViewInput} from './VerifyContactStepView/VerifyContactStepViewInput';

export type ContactChannel = 'email' | 'phone';

export type VerifyContactStep = 'input' | 'code' | 'success';

export type VerifyContactMode = 'add' | 'verify' | 'edit';

export interface VerifyContactDialogViewProps {
  channel: ContactChannel;
  intro?: {title: string; subtitle: string};
  onClose: () => void;
  onVerified: (verifiedValue: string) => void | Promise<void>;
}

export const VerifyContactDialogView: React.FC<
  VerifyContactDialogViewProps
> = ({channel, intro, onClose, onVerified}) => {
  const flow = useVerifyContactFlow({channel, onVerified, onClose});

  return (
    <BaseDialog
      open
      onClose={flow.handleClose}
      maxWidth={'sm'}
      actions={[flow.primaryAction]}>
      <Box sx={{px: 3, py: 2}}>
        {flow.step === 'success' && (
          <VerifyContactStepViewSuccess flow={flow} />
        )}
        {flow.step === 'code' && <VerifyContactStepViewCode flow={flow} />}
        {flow.step === 'input' && (
          <VerifyContactStepViewInput flow={flow} intro={intro} />
        )}
      </Box>
    </BaseDialog>
  );
};
